<script setup>
import 'vue3-carousel/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

import c1 from '@/assets/img/brands/c1.png'
import c2 from '@/assets/img/brands/c2.png'
import c3 from '@/assets/img/brands/c3.png'
import c4 from '@/assets/img/brands/c4.png'
import c5 from '@/assets/img/brands/c5.png'
import c6 from '@/assets/img/brands/c6.png'
import c7 from '@/assets/img/brands/c7.png'
import c8 from '@/assets/img/brands/c8.png'
import c9 from '@/assets/img/brands/c9.png'
import c10 from '@/assets/img/brands/c10.png'
import c11 from '@/assets/img/brands/c11.png'

const props = defineProps({
    clients: {
        type: Array,
        default: () => []
    }
})

const fallbackBrands = [
    { src: c1, alt: 'Client 1', client: 'kai' },
    { src: c2, alt: 'Client 2', client: 'pertamina' },
    { src: c3, alt: 'Client 3', client: 'telkom' },
    { src: c4, alt: 'Client 4', client: 'bri' },
    { src: c5, alt: 'Client 5', client: 'mandiri' },
    { src: c6, alt: 'Client 6', client: 'astra' },
    { src: c7, alt: 'Client 7', client: 'unilever' },
    { src: c8, alt: 'Client 8', client: 'tokopedia' },
    { src: c9, alt: 'Client 9', client: 'traveloka' },
    { src: c10, alt: 'Client 10', client: 'gojek' },
    { src: c11, alt: 'Client 11', client: 'bukalapak' },
]

const breakpoints = {
    0: { itemsToShow: 2 },
    768: { itemsToShow: 4 },
    992: { itemsToShow: 5 },
    1200: { itemsToShow: 6 },
    1400: { itemsToShow: 7 },
}
</script>

<template>
    <section class="wrapper" style="background-color: #353435;">
        <div class="container py-14 py-md-16 text-center text-white">

            <div class="mx-auto text-white mb-6">
                <h1 class="display-1 mb-3 text-white">
                    Our <span style="color: #ffae0b;">Clients</span>
                </h1>
                <p class="lead">
                    We collaborate with brands, institutions, and organizations across various industries.
                </p>
            </div>

            <Carousel
                :wrap-around="true"
                :autoplay="3000"
                :gap="30"
                :breakpoints="breakpoints"
                class="clients"
            >
                <template v-if="clients.length > 0">
                    <Slide v-for="client in clients" :key="client.id">
                        <div class="item px-5">
                            <a v-if="client.websiteUrl" :href="client.websiteUrl" target="_blank" rel="noopener" class="client-link">
                                <img :src="client.logo" :alt="client.name" class="img-fluid" />
                            </a>
                            <span v-else class="client-link">
                                <img :src="client.logo" :alt="client.name" class="img-fluid" />
                            </span>
                        </div>
                    </Slide>
                </template>
                <template v-else>
                    <Slide v-for="(brand, index) in fallbackBrands" :key="index">
                        <div class="item px-5">
                            <RouterLink :to="{ path: '/works', query: { client: brand.client } }" class="client-link">
                                <img :src="brand.src" :alt="brand.alt" class="img-fluid" />
                            </RouterLink>
                        </div>
                    </Slide>
                </template>
            </Carousel>

        </div>
    </section>
</template>

<style scoped>
.carousel img {
    max-height: 80px;
    object-fit: contain;
    margin: 0 auto;
    filter: brightness(0) invert(1);
}

.client-link {
    display: block;
    cursor: pointer;
}
</style>
